import { NavigationAwareObject } from '../NavigationAwareObject';
import { RenderObject } from '../RenderObject';

export interface NavigationBehaviour {
  attach(navObject: NavigationAwareObject): void;
  detach(navObject: NavigationAwareObject): void;
}

/**
 * Optional base class for behaviours that mutate a {@link RenderObject}'s
 * animation state. Centralises the `entity.animationState?.switchState(...)`
 * guard so behaviours don't repeat it inline.
 */
export abstract class NavigationBehaviourBase implements NavigationBehaviour {
  abstract attach(navObject: NavigationAwareObject): void;
  abstract detach(navObject: NavigationAwareObject): void;

  protected setMoveAnimation(entity: RenderObject, state: 'Idle' | 'Walk' | 'Run'): void {
    entity.animationState?.switchState(state);
  }
}
